"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const core_2 = require("@angular/core");
const platform_browser_1 = require("@angular/platform-browser");
const core_3 = require("@ngx-translate/core");
const FourDInjector_1 = require("../../FourDInjector");
const map_service_1 = require("../../map.service");
class PluginUiSectionComponent {
    constructor(sanitizer, mapService) {
        this.sanitizer = sanitizer;
        this.mapService = mapService;
        this.plugin = null;
        this.item = null;
        this.section = null;
        this.lastMouseEvent = null;
        this.incomingCanvas = null;
        this.translate = null;
        this.translator = null;
        this.selectOpen = false;
        this.translate = FourDInjector_1.FourDInjector.injector.get(core_3.TranslateService);
    }
    ngOnChanges() {
        // console.log('@@UI-section-changes',this.plugin,this.item,this.section, this.incomingCanvas, this.incomingCanvasContainer );
        if (this.plugin) {
            this.translator = this.plugin.meta.translator;
        }
    }
    ngOnInit() {
        if (this.plugin) {
            this.translator = this.plugin.meta.translator;
        }
        if (!this.incomingCanvasContainer) {
            if (this.section && this.section.canvas) {
                this.incomingCanvas = this.section.canvas;
            }
            if (this.incomingCanvas && this.incomingCanvasContainer) {
                this.incomingCanvasContainer.nativeElement.appendChild(this.incomingCanvas);
            }
        }
        // console.log('@@UI-section-init', this.plugin, this.item, this.section, this.incomingCanvas, this.incomingCanvasContainer );
    }
    ngOnDestroy() {
        this.incomingCanvas = null;
        this.incomingCanvasContainer = null;
        this.plugin = null;
        this.section = null;
        this.item = null;
    }
    toggleSelect(value = null, section = null) {
        this.selectOpen = !this.selectOpen;
        // if these are set, it's usually a close
        if (value && section) {
            section.value = value;
        }
        this.plugin.refresh();
        this.plugin.save();
        /*
        setTimeout ( () => {
          if ( this.selectOpen ) {
            let e = document.getElementsByClassName('fdm-select-open');
            if ( e && e[0] ) {
              this.makeInView(e[0]);
            }
          }
        }, 300 );
        */
        // console.log('@@ toggleSelect', this.selectOpen, value, section );
    }
    radioSelect(value = null, section = null) {
        if (value && section) {
            section.value = value;
        }
        this.plugin.refresh();
        this.plugin.save();
        // console.log('@@ radioSelect', value, section );
    }
    showOptions(section = null) {
        if (section) {
            alert(section.options);
        }
    }
    getLocalisedValue(value = 10) {
        return value + 'm';
    }
    /*
    getPixelsFromPercent ( percent:number = 10 ) {
      // return the number of pixels that is X percent of 200 (height of a legend bar)
      return percent * 2;
    }
    */
    makeInView(e) {
        let max = document.documentElement.scrollHeight;
        let rect = e.getBoundingClientRect();
        console.log("@@MAKE_IN_VIEW", { element: e, rect: rect });
        let oldY = rect.y + 'px';
        let newY = (max - rect.height) + 'px';
        if (rect.y + rect.height > max) {
            // e.style.top = newY;
        }
        console.log("@@MAKE_IN_VIEW", { newY: newY, oldY: oldY, max: max, height: rect.height });
    }
    rounding(num) {
        return Math.round(num);
    }
}
exports.PluginUiSectionComponent = PluginUiSectionComponent;
